import publicIp from 'public-ip';

export const toIndianCurrency = (num) => {
  const curr = num.toLocaleString('en-IN', {
    style: 'currency',
    currency: 'INR',
  });
  return curr;
};
export const maskingFunction = (input, ismasked, count) => {
  if (ismasked === true && input !== undefined) {
    if (input.length > 0) {
      let subNum = input
        .toString()
        .substring(input.length - count, input.length);
      let maskedValue = 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX';
      let maskeData = maskedValue.substring(1, input.length - count + 1);
      subNum = maskeData + subNum;
      return subNum;
    } else {
      return input;
    }
  } else {
    return input;
  }
};

export const toIndianCurrencywithoutSymbol = (num) => {
  const curr = num.toLocaleString('en-IN');
  return curr;
};

let cachedIP = null;
export const getClientIp = async () => {
  if (cachedIP) { return cachedIP; }
  cachedIP = await publicIp.v4({
    fallbackUrls: ['https://ifconfig.co/ip'],
  });
  return cachedIP;
};

export const setLocalData = async (key, value) => {
  await localStorage.setItem(key, value);
};

export const getLocalData = async (key) => {
  let value = await localStorage.getItem(key);

  return value;
};

export const inputAlphaNumeric = (e, callback) => {
  const value = e.target.value
    ? e.target.value.replace(/[^0-9a-zA-Z]+/gi, '')
    : '';

  if (e.target.value !== value) {
    e.target.value = value;
  }

  if (typeof callback === 'function') {
    return callback(value);
  }
};
